import { comparisonBucket } from '@/modules/review/verdict-readers';
import type { BulkRunDetail } from '@/services/ai-function.service';
import type { BulkRunItem } from '@/types/websocket.types';

/** What the thread needs to know about a run: a live bulk-run item carries it, a stored run derives it. */
export type RunFacts = Pick<BulkRunItem, 'status' | 'error' | 'bucket' | 'requestId' | 'escalation'>;

export const storedRunFacts = (detail: BulkRunDetail): RunFacts => ({
	status: detail.error !== null ? 'failed' : 'done',
	error: detail.error,
	bucket: comparisonBucket(detail.comparison),
	requestId: detail.requestId,
	escalation: detail.escalation ?? null
});
